import React from 'react';
import styled from 'styled-components'
import Header from './../../Resources/AppScreens/CommonComponents/Campus/Navigation.svg';
import Custom0 from './../../Resources/AppScreens/CommonComponents/Campus/Style 8.svg';

import Custom1 from './../../Resources/AppScreens/CommonComponents/Campus/Style 7.svg';
import Custom2 from './../../Resources/AppScreens/CommonComponents/Campus/Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Campus/Bottom Navigation.svg';
import CampusComponents from '../../Resources/AppScreens/Preview-Features/Campus';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 6px;
    &>* {
        margin-top: 5px;
    }
`;

const CampusPreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src= {Custom0} />
        <img src={Custom1} style={{marginTop: "4px"}} />
        <img src={Custom2} />
        {features && features.map(feature => CampusComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default CampusPreview;

